import "bootstrap";
import $ from 'jquery'
import 'jquery-ui-dist/jquery-ui';
import Swiper from 'swiper';
import Hls from 'hls.js';

var month = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
var video_open = false;
var mouse_move = false;
var program_open = false;
var channels_open = false;

var timer_interval;
var full_palylist;
var epg_palylist;
var video = document.getElementById('video');
var videoSrc;
var timestep = 0;
var hls = new Hls({
    liveDurationInfinity: true
});
var islive = false;

var req = null;

var currentstart = 0;
var currentstop = 0;
var currenttime = 0;

var live_seek = false;
var live_seek_pos = 0;
var channel_select = null;

$(window).resize(function(){

});
$(window).resize();

var exp_date = null;

var adult_auth = false;

if (localStorage.getItem('login')!= undefined){
    var login = localStorage.getItem('login');
    var password = localStorage.getItem('password');
    if (localStorage.getItem('adult')!= undefined){

        $.get( "https://iptvstream.site/player_api.php?username="+login+"&password="+password, function( dta ) {
            // var userdata = JSON.parse(dta);
            var diffDays = Math.ceil((dta.user_info.exp_date*1000 - (new Date().getTime())) / (1000 * 3600 * 24));
            if (diffDays < 4 && diffDays >= 0){
                exp_date = new Date(dta.user_info.exp_date*1000);
                $("#exp_date").html('Срок действия вашего абонемента<br> истекает ' + exp_date.getDate() + '.' + (exp_date.getMonth() + 1) + '.' + exp_date.getFullYear() + '  в ' + (exp_date.getHours() < 10 ? '0' + exp_date.getHours() : exp_date.getHours()) + ':' + (exp_date.getMinutes() < 10 ? '0' + exp_date.getMinutes() : exp_date.getMinutes()));
            }

            $.get( "http://germanyproxy.iptvstream.site/tools/playlist_json?login="+login+"&password="+password, function( data ) {
                full_palylist = JSON.parse(data);
                $("#player-layer").addClass('visible');
                $("#start-player-preloader").hide();
                $(".player-form").hide();
            });
        }).fail(function (){
            $('#player-layer').remove();
            $('#account-is-blocked').show();
            $("#start-player-preloader").hide();
        });

    }else{
        $("#start-player-preloader").hide();
        $("#adult-form").show();
    }
}else{
    $("#start-player-preloader").hide();
    $("#start-form").show();
    $("#start-form .light-btn").on('click', function (){
        $('#start-form').hide();
        $('#promocode-form').show()
    });
    $("#promocode-form .light-btn").on('click', function (){
        var login = $("#login").val();
        var password = $("#password").val();
        $('#promocode-form').hide();
        $("#start-player-preloader").show();
        $.get( "https://iptvstream.site/player_api.php?username="+login+"&password="+password, function( dta ) {
            var diffDays = Math.ceil((dta.user_info.exp_date*1000 - (new Date().getTime())) / (1000 * 3600 * 24));
            if (diffDays < 4 && diffDays >= 0){
                exp_date = new Date(dta.user_info.exp_date*1000);
                $("#exp_date").html('Срок действия вашего абонемента<br> истекает ' + exp_date.getDate() + '.' + (exp_date.getMonth() + 1) + '.' + exp_date.getFullYear() + '  в ' + (exp_date.getHours() < 10 ? '0' + exp_date.getHours() : exp_date.getHours()) + ':' + (exp_date.getMinutes() < 10 ? '0' + exp_date.getMinutes() : exp_date.getMinutes()));
            }

            $.get( "http://germanyproxy.iptvstream.site/tools/playlist_json?login="+login+"&password="+password, function( data ) {
                full_palylist = JSON.parse(data);
                $("#start-player-preloader").hide();
                if (full_palylist.length == 0){
                    $("#login").val('');
                    $("#password").val('');
                    $('#promocode-form').show();
                    alert('Проверьте правильность ввода данных!');
                }else{
                    localStorage.setItem('login', login);
                    localStorage.setItem('password', password);
                    $('#promocode-form').hide();
                    $('#adult-form').show();
                }
                // console.log(full_palylist);
                // $("#player-layer").addClass('visible');
            });
        }).fail(function (){
            $('#player-layer').remove();
            $('#account-is-blocked').show();
            $("#start-player-preloader").hide();
        });

    });

}

$("#adult-form .light-btn").on('click', function (){
    if ($('#pass1').val() != $('#pass2').val() || $('#pass1').val() == ''){
        alert('Пароли должны совпадать и не должны быть пустыми');
        $("#start-player-preloader").hide();
        $('#pass1').val('');
        $('#pass2').val('');
        $("#adult-form").show();
    }else{
        localStorage.setItem('adult', $('#pass1').val());
        $("#player-layer").addClass('visible');
        $("#start-player-preloader").hide();
        $(".player-form").hide();
    }
});

$("#open18-form .light-btn").on('click', function (){
    if (localStorage.getItem('adult')!= undefined) {
        if ($('#adultpass').val() != localStorage.getItem('adult')) {
            alert('Проверьте правильность ввода');
            $('#adultpass').val('');
        } else {
            adult_auth = true;
            $("#player-layer").addClass('visible');
            $("#open18-form").hide();
            channel_select.click();
        }
    }
});



var video = document.getElementById('video');

document.addEventListener("fullscreenchange", onFullScreenChange, false);
document.addEventListener("webkitfullscreenchange", onFullScreenChange, false);
document.addEventListener("mozfullscreenchange", onFullScreenChange, false);

function onFullScreenChange(){
    var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

    if (fullscreenElement == null){
        $("#video-field").removeClass('fullscreen');
        $(window).resize();
    }
}

// $(".change18").on('click', function (){
//     $("#player-layer").hide();
//     $("#change-adult-form").show();
// });
// $(".change18-btn").on('click', function (){
//     $("#player-layer").show();
//     $("#change-adult-form").hide();
// });
// $(".to-player").on('click', function (){
//     $("#adult-form").hide();
//     $("#player-layer").show();
// });
$("a.blocked-exit").on('click', function (){
    localStorage.clear();
    window.location.reload();
});
$(".action-item.exit-btn").on('click', function (){
    localStorage.clear();
    window.location.reload();
});
$(".change-token").on('click', function (){
    $("#player-layer").hide();
    $("#change-token-form").show();
});
$(".change-token-btn").on('click', function (){
    $("#player-layer").show();
    $("#change-token-form").hide();
});
$("#pause-btn").on('click', function (){
    $(this).toggleClass('play');
    if ($(this).hasClass('play')){
        video.pause();
    }else {
        video.play();
    }
});

$(".to-categories").on('click', function (){
    clearInterval(timer_interval);

    program_open = false;
    channels_open = false;
    video_open = false;
    $("#home-categories").addClass('active');
    $("#home-channels").removeClass('active');
    $(".select-category").removeClass('active');
    video.pause();
    $("#pause-btn").removeClass('play');
    $("#video-player").hide();
});
$(".home-category").on('click', function (){
    clearInterval(timer_interval);

    var cat = $(this).find('span').html();
    $(".select-category b").html(cat);
    $('#home-channels').html('');
    $('#video-channels-list-scroll').html('');
    var fav_arr = [];
    if (localStorage.getItem('favorite')!= undefined){
        fav_arr = localStorage.getItem('favorite');
    }
    for (var channel in full_palylist) {
        if (full_palylist[channel].category == cat || cat=='Все каналы'){
            var isFav = '';
            var tit = full_palylist[channel].name;
            if (fav_arr.includes( tit )){
                isFav = 'active';
            }
            var chHtml = '<div class="channel-item" data-title="'+full_palylist[channel].name+'" data-dur="'+full_palylist[channel].arch_duration+'" data-tvg="'+full_palylist[channel].tvg.url+'" data-url="'+full_palylist[channel].url+'" data-cat="'+full_palylist[channel].category+'">\n' +
                '   <img src="'+full_palylist[channel].logo+'" alt="">\n' +
                '   <span>'+full_palylist[channel].name+'</span>\n' +
                '   <div class="fav-btn '+isFav+'"></div>\n' +
                '</div>'
            $('#home-channels').append(chHtml);
            $('#video-channels-list-scroll').append(chHtml);
        } else if (cat == 'Избранное'){
            var isFav = '';
            var tit = full_palylist[channel].name;
            if (fav_arr.includes( tit )){
                isFav = 'active';
                var chHtml = '<div class="channel-item" data-title="'+full_palylist[channel].name+'" data-dur="'+full_palylist[channel].arch_duration+'" data-tvg="'+full_palylist[channel].tvg.url+'" data-url="'+full_palylist[channel].url+'" data-cat="'+full_palylist[channel].category+'">\n' +
                    '   <img src="'+full_palylist[channel].logo+'" alt="">\n' +
                    '   <span>'+full_palylist[channel].name+'</span>\n' +
                    '   <div class="fav-btn '+isFav+'"></div>\n' +
                    '</div>'
                $('#home-channels').append(chHtml);
                $('#video-channels-list-scroll').append(chHtml);
            }
        }
    }
    video_open = false;
    $("#home-categories").removeClass('active');
    $("#home-channels").addClass('active');
    $(".select-category").addClass('active');
    video.pause();
    $("#show-program").show();
    $("#show-channels").show();
    $("#video-program-list").removeClass('show');
    $("#video-channels-list").hide();
    $("#pause-btn").removeClass('play');
    $("#video-player").hide();
});
$(".select-category-item").on('click', function (){
    $(".home-category").eq($(this).index()).click();
});
// $(".open18-btn").on('click', function (){
//     $("#player-layer").show();
//     $("#home-categories").removeClass('active');
//     $("#home-channels").addClass('active');
//     $(".select-category").addClass('active');
//     $("#open18-form").hide();
// });

$("#show-program").on('click', function (){
    program_open = true;
    $(this).hide();
    $("#video-program-list").addClass('show');
    setTimeout(function (){
        // $("#video-program-list-scroll").scrollTop($(".program-item.active").position().top - $("#video-program-list-scroll").height() / 2);
    },100)
});
$("#show-channels").on('click', function (){
    channels_open = true;
    $(this).hide();
    $("#video-channels-list").show();
});

$("#video-channels-list .close-list-btn").on('click', function (){
    channels_open = false;
    $("#video-channels-list").hide();
    $("#show-channels").show();
});
$("#video-program-list .close-list-btn").on('click', function (){
    program_open = false;
    $("#video-program-list").removeClass('show');
    $("#show-program").show();
});

$(document).on('click', ".fav-btn", function (e){
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass('active');
    var fav_arr = [];
    if (localStorage.getItem('favorite')!= undefined){
        fav_arr = localStorage.getItem('favorite').split(',');
    }
    var tit = $(this).parent().attr('data-title');
    if (fav_arr.includes( tit )){
        fav_arr.splice(fav_arr.indexOf(tit), 1);
    }else{
        fav_arr[fav_arr.length] = tit;
    }
    localStorage.setItem('favorite', fav_arr.join(','));
});
$(document).on('click', ".channel-item", function (e){
    $(".program-title").html('');
    $(".channel-title").html($(this).find('span').html());
    $("#video-program-list-scroll").html('');
    $('#video-program-date-list').html('');
    $("#progress-line").width(0);
    $("#progress-time").html('00:00:00');
    islive = true;
    if (req != null){
        req.abort();
    }
    clearInterval(timer_interval);

    $(".channel-item").removeClass('active');
    $(".channel-item").eq($(this).index()).addClass('active');

    channel_select = $(this);

    if ($(this).attr('data-cat') == 'Для взрослых' && !adult_auth){
        $("#player-layer").removeClass('visible');
        $("#open18-form").show();
        return false;
    }

    $("#pause-btn").removeClass('play');
    var arch_dur = $(this).attr('data-dur');
    req = $.get($(this).attr('data-tvg'), function( data ) {
        epg_palylist = JSON.parse(data);
        // console.log(epg_palylist);
        var dates_arr = [];
        for (var program in epg_palylist) {
            var now = new Date();
            var date = new Date(epg_palylist[program].startUnix);
            var stopTime = new Date(epg_palylist[program].stopUnix);
            // console.log(date);

            var month_arr = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'];

            var hours = "0" + date.getHours();
            var minutes = "0" + date.getMinutes();
            var arch = '';
            var active = '';
            var datedata = '';
            if (now > date){
                arch = 'archive';
                // if (arch_dur == "0"){
                if (now - 86400000*arch_dur > stopTime){
                    continue;
                } else {
                    // arch = '';
                }
                if (arch_dur == '0'){
                    arch = '';
                }

                // }
            }
            if(now < stopTime && now > date){
                active = 'active';
                currenttime = now;
                currentstart = date;
                currentstop = stopTime;
                $(".program-title").html(epg_palylist[program].title);
            }

            if(dates_arr.indexOf(date.getDate()+' '+month_arr[date.getMonth()]) == -1)
            {
                dates_arr.push(date.getDate()+' '+month_arr[date.getMonth()]);
                datedata = date.getDate()+' '+month_arr[date.getMonth()];
                $('#video-program-date-list').append('<div class="video-program-date">'+date.getDate()+' '+month_arr[date.getMonth()]+'</div>')
            }


            var prHtml = '<div class="program-item '+arch+' '+active+'" data-day="'+datedata+'" data-title="'+epg_palylist[program].title+'" data-url="'+epg_palylist[program].archiveUri+'" data-start="'+epg_palylist[program].startUnix+'" data-stop="'+epg_palylist[program].stopUnix+'">\n' +
                '  <span><b>'+date.getDate()+' '+month_arr[date.getMonth()]+' '+hours.substr(-2)+':'+minutes.substr(-2)+'</b> '+epg_palylist[program].title+'</span>\n' +
                '</div>'
            $('#home-channels').append(prHtml);
            $('#video-program-list-scroll').append(prHtml);

        }

        $("#progress-line").css({'width': (currenttime - currentstart) * 100 / (currentstop - currentstart) + "%"});

        timestep = 0;
        timer_interval = setInterval(function (){
            var now = new Date();
            if (!document.getElementById('video').paused){
                updateProgressTime((currentstop - now + timestep*1000) / 1000);
            } else {
                timestep++;
            }
        }, 1000)

        $('#video-program-date-list').scrollTop(1000);
        if ($(".program-item.active").length == 0){
            $("#video-program-list-scroll").scrollTop($(".program-item").length * 40);
        }else{
            $("#video-program-list-scroll").scrollTop($(".program-item.active").position().top - $("#video-program-list-scroll").height() / 2);
        }
    });

    $('#home-categories').removeClass('active');
    $('#home-channels').removeClass('active');
    $('#video-player').show();
    $("#actions-menu").hide();
    video_open = true;

    $("#bookmarks").show();
    $("#data-time").show();
    $("#exp_date").show();
    $(".video-player-content").addClass('active');
    program_open = true;
    channels_open = true;


    if ($(this).parents('#video-channels-list-scroll').length == 0){
        $("#show-program").show();
        $("#show-channels").show();
    }else{
        if (document.body.clientWidth > 500){
            $("#show-program").hide();
            $("#video-program-list").addClass('show');
        }else{
            $("#video-channels-list").removeClass('show');
            $("#show-channels").show();
        }
    }

    $("#about-program img").attr('src', $(this).find('img').attr('src'))
    videoSrc = $(this).attr('data-url');
    $("#video-preloader").show();
    if (Hls.isSupported()) {
        hls.stopLoad();
        hls.detachMedia()
        hls = new Hls({
            liveDurationInfinity: true
        });
        hls.loadSource(videoSrc);
        hls.attachMedia(video);
        hls.on(Hls.Events.BUFFER_APPENDED, function () {
            $("#video-preloader").hide();
        });
        hls.on(Hls.Events.FRAG_CHANGED, function () {
            // console.log('update');
            if (islive){
                var now = new Date();
                $("#progress-line").css({'width': (now - currentstart) * 100 / (currentstop - currentstart) + "%"});
            }
            // $("#video-preloader").show();
        });
        video.play();
    }
    else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc;
    }

});
$(document).on('click', ".video-program-date", function (e) {
    $("#video-program-list-scroll").scrollTop($('.program-item[data-day="'+$(this).html()+'"]').index() * 40);
});
$(document).on('click', ".program-item", function (e){
    videoSrc = $(this).attr('data-url');
    currentstart = new Date($(this).attr('data-start')*1);
    currentstop= new Date($(this).attr('data-stop')*1);

    clearInterval(timer_interval);

    $("#pause-btn").removeClass('play');
    $(".program-title").html($(this).attr('data-title'));
    $(".program-item").removeClass("active");
    $(this).addClass("active");
    $("#video-preloader").show();
    $("#progress-line").width(0);
    islive = false;
    if (Hls.isSupported()) {
        hls.stopLoad();
        hls.detachMedia()
        hls = new Hls({
            liveDurationInfinity: true
        });
        hls.loadSource(videoSrc);
        hls.attachMedia(video);
        hls.on(Hls.Events.BUFFER_APPENDED, function () {
            $("#video-preloader").hide();
        });
        hls.on(Hls.Events.LEVEL_LOADED, function () {
        });
        hls.on(Hls.Events.MANIFEST_PARSED,function() {
        });
        hls.on(Hls.Events.FRAG_CHANGED, function () {
            if (!islive){
                var pproc = video.currentTime*100 / ((currentstop - currentstart)/1000);
                $("#progress-line").css({'width': pproc + "%"});
            }
            // $("#video-preloader").show();
        });
        hls.on(Hls.Events.BUFFER_EOS, function () {
            if (!islive){
                // if (video.currentTime == video.duration){
                //     console.log('finish');
                setTimeout(function () {
                    if ($("#progress-line").width() > 100){
                        $(".program-item").eq($(".program-item.active").index() + 1).click();
                    }
                }, 6000)
                // }
            }
            // $("#video-preloader").show();
        });

        hls.on(Hls.ErrorDetails.MANIFEST_LOAD_ERROR,function() {
            console.log('error');
        });


        timer_interval = setInterval(function (){
            var now = video.currentTime;
            updateProgressTime((currentstop - currentstart)/1000 - now);
        }, 1000)


        video.play();
        $("#video-program-list").removeClass('show');
        $("#show-program").show();
        $("#video-channels-list").hide();
        $("#show-channels").show();

        if (live_seek){
            live_seek = false;
            var now = new Date();
            var ct = Math.ceil((currentstop - currentstart) * live_seek_pos / 1000);
            video.currentTime = ct;
            video.play();

        }

    }
    else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc;
    }

});

$("#progress-bar").on('click', function (e){
    if ($('.program-item.archive').length > 0){
        var pos_x = e.pageX - $("#progress-bar").offset().left;
        var proc = pos_x / $("#progress-bar").width();
        $("#video-preloader").show();
        var now = new Date();
        if (!islive) {
            var ct = Math.ceil((currentstop - currentstart) * proc / 1000);
            if (currentstart.getTime() + ct*1000 > now){
                $(".channel-item.active").click();
                $("#show-program").show();
                $("#video-program-list").removeClass('show');
            }else{
                video.currentTime = ct;
                video.play();
            }
        }else{
            live_seek = true;
            live_seek_pos = proc;
            var ct = Math.ceil((currentstop - currentstart) * proc / 1000);
            if (currentstart.getTime() + ct*1000 > now){
                $(".channel-item.active").click();
                $("#show-program").show();
                $("#video-program-list").removeClass('show');

            }else{
                $(".program-item.active").click();
            }

        }
    }

});

$('body').on('mousemove', function (e){
    if (video_open){
        video_open = true;
        $(".video-player-content").addClass('active');
        $("#actions-menu").fadeIn(300);
        $("#bookmarks").fadeIn(300);
        $("#data-time").fadeIn(300);
        $("#exp_date").fadeIn();
        if (!program_open){
            $("#show-program").fadeIn(300);
        }
        if (!channels_open){
            $("#show-channels").fadeIn(300);
        }
        move_iteration = 0;

        if (currentstop > 0){
            var ppos_x = e.pageX - $("#progress-bar").offset().left;
            let timePercent = ppos_x / $("#progress-bar").width();
            let currentProgramLength = (currentstop.getTime() - currentstart.getTime()) / 1000;
            let fullTime = currentProgramLength;
            let moveTime = currentProgramLength*timePercent;
            $("#progress-time-label").css({'left': ppos_x});
            $("#progress-time-label span").html(setTimeString(moveTime) + ' / '+setTimeString(fullTime));
        }
    }
});

var move_iteration = 0;
setInterval(function (){
    move_iteration++;
    if (move_iteration == 4){
        if (video_open){
            program_open = false;
            channels_open = false;
            $(".video-player-content").removeClass('active');
            $("#video-channels-list").hide();
            $("#video-program-list").removeClass('show');
            $("#actions-menu").hide();
            $("#bookmarks").hide();
            $("#data-time").hide();
            $("#exp_date").hide();
        }
    }
}, 1000)

$("#video-program-list-scroll").on('scroll', function (){
    move_iteration = 0;
})
$("#video-channels-list-scroll").on('scroll', function (){
    move_iteration = 0;
})

$("#fullscreen").on('click', function (){
    $(this).toggleClass('active');
    if ($(this).hasClass('active')){
        openFullscreen();
    }else{
        closeFullscreen();
    }
});

$("#volume-layer-btn").draggable({
    containment: "parent",
    drag: function( event, ui ) {
        video.volume = 0.01 * $("#volume-layer-btn").position().left
    }
})
$("#volume-off").on('click', function (){
    $("#volume-layer-btn").css({'left': 0});
    video.volume = 0.01 * $("#volume-layer-btn").position().left
});
$("#volume-on").on('click', function (){
    $("#volume-layer-btn").css({'left': 100});
    video.volume = 0.01 * $("#volume-layer-btn").position().left
});

SetTime();



function SetTime(){
    var date = new Date;
    if (exp_date < date && exp_date != null){
        $('#player-layer').remove();
        $('#account-is-blocked').show();
        $("#start-player-preloader").hide();
    }
    var mon = date.getMonth();
    var day = date.getDate();
    var hour = date.getHours();
    var min = date.getMinutes();
    if (hour < 10){
        hour = '0'+hour;
    }
    if (min < 10){
        min = '0'+min;
    }
    if (day < 10){
        day = '0' + day;
    }
    $('#data-time b').html(hour+':'+min);
    $('#data-time span').html(month[mon]+', '+day);

    setInterval(function (){
        var date = new Date;
        var hour = date.getHours();
        var min = date.getMinutes();
        if (hour < 10){
            hour = '0'+hour;
        }
        if (min < 10){
            min = '0'+min;
        }
        $('#data-time b').html(hour+':'+min);
    }, 60000);
}

function updateProgressTime(timer){
    if (timer >= 0){
        var th = Math.floor(timer / 3600 % 24);
        var tm = Math.floor(timer / 60 % 60);
        var ts = Math.floor(timer % 60);
        if (th < 10){
            th = '0'+th;
        }
        if (tm < 10){
            tm = '0'+tm;
        }
        if (ts < 10){
            ts = '0'+ts;
        }
        $("#progress-time").html(th+':'+tm+':'+ts);
    }

}
function setTimeString(time){
    var th = Math.floor(time / 3600 % 24);
    var tm = Math.floor(time / 60 % 60);
    var ts = Math.floor(time % 60);
    if (th < 10){
        th = '0'+th;
    }
    if (tm < 10){
        tm = '0'+tm;
    }
    if (ts < 10){
        ts = '0'+ts;
    }
    return th+':'+tm+':'+ts;
}


/* Get the documentElement (<html>) to display the page in fullscreen */
var elem = document.documentElement;

/* View in fullscreen */
function openFullscreen() {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
}

/* Close fullscreen */
function closeFullscreen() {

    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
    }

}

function num_word(value, words){
    value = Math.abs(value) % 100;
    var num = value % 10;
    if(value > 10 && value < 20) return words[2];
    if(num > 1 && num < 5) return words[1];
    if(num == 1) return words[0];
    return words[2];
}

